import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Link, List, ListItem, Typography } from '@coolblue-development/freddy';
import assortmentSelectNavigationTrigger from '@coolblue-development/ga4-events/triggers/AssortmentEntranceNavigation/selectNavigationTrigger';
import horizontalSelectNavigationTrigger from '@coolblue-development/ga4-events/triggers/HorizontalNavigation/selectNavigationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { AssortmentEntranceEventFeature, HortizontalNavigationEventFeature, } from './CategoryNavigation.types.js';
export default function CategoryNavigationCategory({ navigationItem, index, totalIndices, variant = 'dropdown', }) {
    const { trackEvent } = useAnalytics();
    const triggerEvent = (variant, level, item, index, totalIndices) => {
        const params = {
            index: index + 1, // 1-based index for tracking
            total_indices: totalIndices,
            url: item.url,
            redirect: item.title,
        };
        if (variant === 'bar') {
            trackEvent(horizontalSelectNavigationTrigger({
                ...params,
                sub_feature: HortizontalNavigationEventFeature[level],
            }));
        }
        else {
            trackEvent(assortmentSelectNavigationTrigger({
                ...params,
                sub_feature: AssortmentEntranceEventFeature[level],
            }));
        }
    };
    if (!navigationItem.indexable) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(ListItem, { pb: 600, sx: {
            breakInside: 'avoid',
        }, children: _jsxs(Flex, { direction: "column", gap: 100, children: [_jsx(Link, { href: navigationItem.url, onClick: () => triggerEvent(variant, 'SECONDARY', navigationItem, index, totalIndices), children: _jsx(Typography, { variant: "h4", component: "span", color: "interactiveBase", children: navigationItem.title }) }), _jsx(List, { marker: "none", gap: "compact", children: navigationItem.children.map((navigationSubItem, index) => (_jsx(ListItem, { children: _jsx(Link, { href: navigationSubItem.url, variant: "subtle", onClick: () => triggerEvent(variant, 'TERTIARY', navigationSubItem, index, navigationItem.children.length), children: navigationSubItem.title }) }, navigationSubItem.id))) })] }) }));
}
//# sourceMappingURL=CategoryNavigationCategory.js.map